import Particle from 'core/display/Particle'
import { signal } from 'services/SignalsService'

export default class SingleWinParticle extends Particle {
  constructor(data) {
    super(data)
    this.resize(this)
  }

  resize(object){
    signal.on('RESIZE', function ({ scale }) {
      object.scale.set( scale / 2)
    })
  }

  createSignals(emitter, data) {
    signal.on(`PARTICLE:${data.from}`, () => {
      emitter.emit = true
    })

    if(data.from === 'mega') {
      signal.on('WIN-ANIMATE:DONE', () => {
        emitter.cleanup()
      })
      signal.on('COIN:OUT', () => {
        this.offEmit(emitter)
      })
    }
    signal.on(`PARTICLE:${data.to}`, () => {
      emitter.cleanup()
      this.offEmit(emitter)
    })
    signal.on('WIN-ANIMATE:DONE', () => {
      emitter.cleanup()
      this.offEmit(emitter)
    })
  }

  offEmit(emitter) {
    if(emitter.emit){
      emitter.emit = false
    }
  }
}
